import { useState } from 'react';
import { Link } from 'react-router-dom';
import { inputClass } from '../components/ui/inputClass';
import { BrandMark } from '../components/ui/BrandMark';
import { forgotPassword } from '../api/auth';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault(); setErr(null); setBusy(true);
    try {
      await forgotPassword(email);
      setSent(true);
    } catch { setErr('Something went wrong. Please try again.'); }
    finally { setBusy(false); }
  }

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-950 flex items-center justify-center p-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <BrandMark />
          <h1 className="text-3xl font-bold text-slate-900 dark:text-slate-50">Forgot password</h1>
          <p className="text-slate-500 dark:text-slate-400 mt-1 text-sm">
            We'll send you a reset link.
          </p>
        </div>
        {sent ? (
          <div className="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-6 space-y-3 shadow-sm text-sm text-slate-600 dark:text-slate-300">
            <p>If that email is registered, a reset link is on its way.</p>
            <p>
              <Link className="font-medium text-teal-600 dark:text-teal-400 hover:underline" to="/login">
                Back to sign in
              </Link>
            </p>
          </div>
        ) : (
          <form onSubmit={onSubmit} className="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-6 space-y-4 shadow-sm">
            <div>
              <label className="mb-1 block text-sm font-medium text-slate-700 dark:text-slate-300">Email</label>
              <input
                className={inputClass}
                type="email"
                required
                placeholder="you@example.com"
                value={email}
                onChange={e => setEmail(e.target.value)}
              />
            </div>
            {err && <p className="text-sm text-red-500">{err}</p>}
            <button
              className="w-full rounded-lg bg-teal-600 dark:bg-teal-500 py-2.5 text-sm font-semibold text-white hover:bg-teal-700 dark:hover:bg-teal-600 disabled:opacity-50 transition-colors cursor-pointer"
              disabled={busy}
            >
              {busy ? 'Sending…' : 'Send reset link'}
            </button>
            <p className="text-center text-sm text-slate-500 dark:text-slate-400">
              <Link className="font-medium text-teal-600 dark:text-teal-400 hover:underline" to="/login">
                Back to sign in
              </Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
